import produce from "immer";
import {
  EMAILS_WITHOUT_CAMPAIGNS_LIST,
  // CAMPAIGNS_FILTER_DATA,
  CAMPAIGNS_LIST,
  CAMPAIGN_NAME_UPDATE,
  CAMPAIGN_SENT_EDITIONS,
  CAMPAIGN_DELETE,
  ASSET_DELETED,
  CREATE_CAMPAIGN_RECOMMENDED_LISTS,
  SEARCH_CAMPAIGNS_LIST,
  CREATE_CAMPAIGN_RECOMMENDED_CONTACTS,
  GET_CAMPAIGNS_NAMES_ONLY,
  TEST_CAMPAIGN_SEARCH_TERM,
  CREATE_NEW_DRAFT_EDITION,
  ADHOC,
  CAMPAIGN_NAME_DELETE,
  SELECTED_RECOMMENDED_LISTS,
  SELECTED_RECOMMENDED_CONTACTS,
  // CAMPAIGN_UPDATE_LAST_UPDATED,
} from "constants/types/campaignTypes";
import {
  EMAIL_BROWSER_ADD_ARTICLES,
  EMAIL_BROWSER_ADD_EMAIL,
  BROWSER_CREATE_ASSET_DRAFT_WITHOUT_CAMPAIGN,
  CAMPAIGNS_GRAPH_DATA,
  EMAIL_BROWSER,
  DYNAMIC_AUDIENCE_MATCHING,
} from "../../../constants/actionTypes";
import {
  ICampaignItem,
  IAssetItem,
  ICampaignsFilteredState,
  IAssetsWithoutCampaignsState,
  ICampaignsState,
  ILoadingOptionsWithData,
  IGraphDataAction,
  ISearchCampaignState,
  IKeywordsExplorerAction,
  ITemplateItem,
  IFeaturedTemplate,
  IMyTemplate,
  ISharedTemplate,
} from "../interfaces";
import {
  IVersion,
  IRecommendedContact,
  IRecommendedPeopleAction,
  ICampaignsName,
  ICampaignsNamesAction,
} from "../../Campaigns/interfaces";
import {
  IListItem,
  IAudienceAction,
  IAudienceItem,
  IContactItem,
  IRecommendedAudienceListAction,
  IRecommendedAudienceContactAction,
} from "./../Audience/interface";
import { IArticlesItem } from "modules/Content/interfaces";
import { ITemplatesAction } from "./../interfaces";
import * as Interfaces from "./../interfaces";
import { TEMPLATES_TYPE } from "./Components/AdhocTemplates/constants";
import store from "store";

const campaignsInitialState: ICampaignsState = {
  data: Array<ICampaignItem>(),
  message: "",
  success: true,
  allCampaignsName: Array<ICampaignItem>(),
  campaignsUsers: [],
  emailUsers: [],
  hasMoreCampaign: true,
  index: undefined,
  loading: true,
  page: 0,
  articlesCount: 0,
  sentEditions: Array<IVersion>(),
  sentEditionLoading: false,
  sentEditionUpdateSubjectLoading: false,
  sentEditionsAssetName: "",
  sentEditionsAssetType: "",
  sentEditionsAssetKeywords: [],
  createNewDraftLoading: false,
  cloningInProgress: false,
  totalCount: 0,
  prevCampaignId: 0,
  reset: false,
};

const recommendedListsInitialState = {
  data: Array<IListItem>(),
  totalLists: 0,
  loading: false,
};

const recommendedPeopleInitialState = {
  // recommended people
  loading: false,
  data: Array<IContactItem>(),
  totalContacts: 0,
  selectedRecommendedContacts: Array<any>(),
  selectedRecommendedContactsIds: Array<number>(),
  isSelectAllRecommendedContacts: false,
  // search term
  searchTerm: "",
  // dynamic audience
  dynamicKeywords: [] as string[],
  dynamicAudienceLoading: false,
  dynamicAudienceData: Array<IContactItem>(),
  dynamicAudienceTotalContacts: 0,
  selectedDynamicContacts: Array<any>(),
  selectedDynamicContactsIds: Array<number>(),
  // other
  alreadySelectedContacts: Array<number>(),
};

const selectedRecommendedListsState = {
  selectedLists: Array<IListItem>(),
  selectedListsIds: Array<number>(),
  isSelectAllRecommendedLists: false,
  isSelectAllDynamicLists: false,
  isSelectAllSelectedLists: false,
};

const getCampaignNamesInitialState = {
  data: Array<ICampaignsName>(),
  searchTerm: "",
  totalCount: 0,
  loading: false,
};

const keywordsExplorerInitialState = {
  data: Array<IArticlesItem>(),
  loading: false,
};

const getTemplatesInitialState = {
  featured: { total_templates: 0, templates: Array<ITemplateItem>(), page: 0 },
  my_templates: { total_templates: 0, templates: Array<ITemplateItem>(), page: 0 },
  shared: { total_templates: 0, templates: Array<ITemplateItem>(), page: 0 },
  loading: false,
  success: true,
  message: "",
  templateType: "all",
  redirectUrl: "",
};

const selectedRecommendedContactsState = {
  selectedContacts: Array<any>(),
  selectedContactsIds: Array<number>(),
  selectedRecommendedContacts: Array<any>(),
  selectedRecommendedContactsIds: Array<number>(),
  selectedSearchedContacts: Array<any>(),
  selectedSearchedContactsIds: Array<number>(),
  selectedDynamicContacts: Array<any>(),
  selectedDynamicContactsIds: Array<number>(),
  selectAllRecommendedContacts: false,
  unSelectAllRecommendedContacts: false,
  selectAllRecommendedSearchContacts: false,
  unSelectAllRecommendedSearchContacts: false,
  selectAllRecommendedDynamicContacts: false,
  unSelectAllRecommendedDynamicContacts: false,
};

export const selectedRecommendedContactsReducer = (state = selectedRecommendedContactsState, action: any) => {
  const newState = { ...state };
  switch (action.type) {
    //* recommended cases
    case SELECTED_RECOMMENDED_CONTACTS.SELECT_ALL_RECOMMENDED:
      newState.selectAllRecommendedContacts = true;
      newState.unSelectAllRecommendedContacts = false;
      newState.selectedRecommendedContacts = action.payload;
      newState.selectedRecommendedContactsIds = action.payload.map((contact: any) => contact.id);
      let addMore = action.payload.filter((contact: any) => !newState.selectedContactsIds.includes(contact.id));
      let addMoreIds = addMore.map((contact: any) => contact.id);
      newState.selectedContacts = [...newState.selectedContacts, ...addMore];
      newState.selectedContactsIds = [...newState.selectedContactsIds, ...addMoreIds];
      return newState;

    case SELECTED_RECOMMENDED_CONTACTS.UNSELECT_ALL_RECOMMENDED:
      newState.selectAllRecommendedContacts = false;
      newState.unSelectAllRecommendedContacts = true;
      let newSelectedContacts = newState.selectedContacts.filter(
        (contact) => !newState.selectedRecommendedContactsIds.includes(contact.id)
      );
      newState.selectedContacts = [...newSelectedContacts];
      newState.selectedContactsIds = [...newSelectedContacts.map((contact: any) => contact.id)];
      newState.selectedRecommendedContacts = [];
      newState.selectedRecommendedContactsIds = [];
      return newState;

    case SELECTED_RECOMMENDED_CONTACTS.RESET_SELECT_ALL_RECOMMENDED:
      newState.selectAllRecommendedContacts = false;
      newState.unSelectAllRecommendedContacts = false;
      return newState;

    //* Searched cases

    case SELECTED_RECOMMENDED_CONTACTS.SELECT_ALL_SEARCHED:
      newState.selectAllRecommendedSearchContacts = true;
      newState.unSelectAllRecommendedSearchContacts = false;
      newState.selectedSearchedContacts = action.payload;
      newState.selectedSearchedContactsIds = action.payload.map((contact: any) => contact.id);
      let addMoreSearched = action.payload.filter(
        (contact: any) => !newState.selectedContactsIds.includes(contact.id)
      );
      let addMoreSearchedIds = addMoreSearched.map((contact: any) => contact.id);
      newState.selectedContacts = [...newState.selectedContacts, ...addMoreSearched];
      newState.selectedContactsIds = [...newState.selectedContactsIds, ...addMoreSearchedIds];
      return newState;

    case SELECTED_RECOMMENDED_CONTACTS.UNSELECT_ALL_SEARCHED:
      newState.selectAllRecommendedSearchContacts = false;
      newState.unSelectAllRecommendedSearchContacts = true;
      let newSelectedSearchedContacts = newState.selectedContacts.filter(
        (contact) => !newState.selectedSearchedContactsIds.includes(contact.id)
      );
      newState.selectedContacts = [...newSelectedSearchedContacts];
      newState.selectedContactsIds = [...newSelectedSearchedContacts.map((contact: any) => contact.id)];
      newState.selectedSearchedContacts = [];
      newState.selectedSearchedContactsIds = [];
      return newState;

    case SELECTED_RECOMMENDED_CONTACTS.RESET_SELECT_ALL_SEARCHED:
      newState.selectAllRecommendedSearchContacts = false;
      newState.unSelectAllRecommendedSearchContacts = false;
      return newState;

    //* Dynamic Cases

    case SELECTED_RECOMMENDED_CONTACTS.SELECT_ALL_DYNAMIC:
      newState.selectAllRecommendedDynamicContacts = true;
      newState.unSelectAllRecommendedDynamicContacts = false;
      newState.selectedDynamicContacts = action.payload;
      newState.selectedDynamicContactsIds = action.payload.map((contact: any) => contact.id);
      let addMoreDynamic = action.payload.filter(
        (contact: any) => !newState.selectedContactsIds.includes(contact.id)
      );
      let addMoreDynamicIds = addMoreDynamic.map((contact: any) => contact.id);
      newState.selectedContacts = [...newState.selectedContacts, ...addMoreDynamic];
      newState.selectedContactsIds = [...newState.selectedContactsIds, ...addMoreDynamicIds];
      return newState;

    case SELECTED_RECOMMENDED_CONTACTS.UNSELECT_ALL_DYNAMIC:
      newState.selectAllRecommendedDynamicContacts = false;
      newState.unSelectAllRecommendedDynamicContacts = true;
      let newSelectedDynamicContacts = newState.selectedContacts.filter(
        (contact) => !newState.selectedDynamicContactsIds.includes(contact.id)
      );
      newState.selectedContacts = [...newSelectedDynamicContacts];
      newState.selectedContactsIds = [...newSelectedDynamicContacts.map((contact: any) => contact.id)];
      newState.selectedDynamicContacts = [];
      newState.selectedDynamicContactsIds = [];
      return newState;

    case SELECTED_RECOMMENDED_CONTACTS.RESET_SELECT_ALL_DYNAMIC:
      newState.selectAllRecommendedDynamicContacts = false;
      newState.unSelectAllRecommendedDynamicContacts = false;
      return newState;

    case SELECTED_RECOMMENDED_CONTACTS.SET:
      if (newState.selectedContactsIds.includes(action.payload.id)) {
        let newSelectedContacts = newState.selectedContacts.filter((contact) => contact.id !== action.payload.id);
        newState.selectedContacts = [...newSelectedContacts];
        newState.selectedContactsIds = [...newSelectedContacts.map((contact: any) => contact.id)];
      } else {
        newState.selectedContacts = [...newState.selectedContacts, action.payload];
        newState.selectedContactsIds = [...newState.selectedContactsIds, action.payload.id];
      }
      if (action.isDynamic) {
        if (newState.selectedDynamicContactsIds.includes(action.payload.id)) {
          let newSelectedDynamicContacts = newState.selectedDynamicContacts.filter(
            (contact) => contact.id !== action.payload.id
          );
          newState.selectedDynamicContacts = [...newSelectedDynamicContacts];
          newState.selectedDynamicContactsIds = [...newSelectedDynamicContacts.map((contact: any) => contact.id)];
          newState.unSelectAllRecommendedDynamicContacts = true;
          newState.selectAllRecommendedDynamicContacts = false;
        } else {
          newState.selectedDynamicContacts = [...newState.selectedDynamicContacts, action.payload];
          newState.selectedDynamicContactsIds = [...newState.selectedDynamicContactsIds, action.payload.id];
          let isAllDynamic = newState.selectedDynamicContactsIds.every((contact: any) =>
            newState.selectedContactsIds.includes(contact)
          );
          if (isAllDynamic) {
            newState.selectAllRecommendedDynamicContacts = true;
            newState.unSelectAllRecommendedDynamicContacts = false;
          } else {
            newState.selectAllRecommendedDynamicContacts = false;
            newState.unSelectAllRecommendedDynamicContacts = false;
          }
        }
      } else if (action.isSearched) {
        if (newState.selectedSearchedContactsIds.includes(action.payload.id)) {
          let newSelectedSearchedContacts = newState.selectedSearchedContacts.filter(
            (contact) => contact.id !== action.payload.id
          );
          newState.selectedSearchedContacts = [...newSelectedSearchedContacts];
          newState.selectedSearchedContactsIds = [
            ...newSelectedSearchedContacts.map((contact: any) => contact.id),
          ];
          newState.unSelectAllRecommendedSearchContacts = true;
          newState.selectAllRecommendedSearchContacts = false;
        } else {
          newState.selectedSearchedContacts = [...newState.selectedSearchedContacts, action.payload];
          newState.selectedSearchedContactsIds = [...newState.selectedSearchedContactsIds, action.payload.id];
          let isAllSearch = newState.selectedSearchedContactsIds.every((contact: any) =>
            newState.selectedContactsIds?.includes(contact)
          );
          if (isAllSearch) {
            newState.selectAllRecommendedSearchContacts = true;
            newState.unSelectAllRecommendedSearchContacts = false;
          } else {
            newState.selectAllRecommendedSearchContacts = false;
            newState.unSelectAllRecommendedSearchContacts = true;
          }
        }
      } else if (action.isRecommended) {
        if (newState.selectedRecommendedContactsIds.includes(action.payload.id)) {
          let newSelectedRecommendedContacts = newState.selectedRecommendedContacts.filter(
            (contact) => contact.id !== action.payload.id
          );
          newState.selectedRecommendedContacts = [...newSelectedRecommendedContacts];
          newState.selectedRecommendedContactsIds = [
            ...newSelectedRecommendedContacts.map((contact: any) => contact.id),
          ];
          newState.selectAllRecommendedContacts = false;
          newState.unSelectAllRecommendedContacts = true;
        } else {
          newState.selectedRecommendedContacts = [...newState.selectedRecommendedContacts, action.payload];
          newState.selectedRecommendedContactsIds = [
            ...newState.selectedRecommendedContactsIds,
            action.payload.id,
          ];
          let isAllRecommended = newState.selectedRecommendedContactsIds.every((contact: any) =>
            newState.selectedContactsIds?.includes(contact)
          );
          if (isAllRecommended) {
            newState.selectAllRecommendedContacts = true;
            newState.unSelectAllRecommendedContacts = false;
          } else {
            newState.selectAllRecommendedContacts = false;
            newState.unSelectAllRecommendedContacts = true;
          }
        }
      }
      return newState;

    case SELECTED_RECOMMENDED_CONTACTS.RESET_ALL:
      newState.selectedContacts = Array<any>();
      newState.selectedContactsIds = Array<number>();
      newState.selectedRecommendedContacts = Array<any>();
      newState.selectedRecommendedContactsIds = Array<number>();
      newState.selectedSearchedContacts = Array<any>();
      newState.selectedSearchedContactsIds = Array<number>();
      newState.selectedDynamicContacts = Array<any>();
      newState.selectedDynamicContactsIds = Array<number>();
      newState.selectAllRecommendedContacts = false;
      newState.unSelectAllRecommendedContacts = false;
      newState.selectAllRecommendedSearchContacts = false;
      newState.unSelectAllRecommendedSearchContacts = false;
      newState.selectAllRecommendedDynamicContacts = false;
      newState.unSelectAllRecommendedDynamicContacts = false;
      return newState;

    default:
      return newState;
  }
};

export const selectedRecommendedListsReducer = (state = selectedRecommendedListsState, action: any) => {
  const newState = { ...state };
  switch (action.type) {
    case SELECTED_RECOMMENDED_LISTS.SET_SELECT_ALL:
      let alreadySelectedListsIds = [...newState.selectedListsIds];
      let newSelectedLists = [...action.selectedLists];
      let newSelectedListsIds = [...action.selectedLists?.map((item: any) => item.id)];
      let combinedIds = [...new Set([...alreadySelectedListsIds, ...newSelectedListsIds])];
      let combinedLists: any = [];
      newState.selectedLists.forEach((item: any) => {
        if (combinedIds.includes(item.id)) {
          combinedLists.push(item);
        }
      });
      newSelectedLists.forEach((item: any) => {
        if (combinedIds.includes(item.id)) {
          combinedLists.push(item);
        }
      });
      newState.selectedLists = combinedLists;
      newState.selectedListsIds = combinedIds;
      newState.isSelectAllRecommendedLists = action.isSelectAll;
      return newState;

    case SELECTED_RECOMMENDED_LISTS.RESET_SELECT_ALL:
      newState.selectedLists = [];
      newState.selectedListsIds = [];
      newState.isSelectAllRecommendedLists = false;
      return newState;

    default:
      return newState;
  }
};

export const campaignsReducer = (state = campaignsInitialState, action: any) => {
  const newState = { ...state };
  switch (action.type) {
    case CAMPAIGNS_LIST.UPDATE_AUDIENCE_COUNT:
      let cid = action.campaign_id;
      let cIndex = 0;
      let _data = state.data.map((item, index) => {
        if (item.campaign_id.toString() == cid) {
          let updatedItem = { ...item };
          updatedItem.total_contacts += action.audience;
          updatedItem.last_update = "just now";
          cIndex = index;
          return updatedItem;
        }
        return item;
      });
      const cItem = _data[cIndex];
      _data.splice(cIndex, 1);
      newState.data = [cItem, ..._data];
      return newState;

    case CAMPAIGNS_LIST.SET_USERS:
      newState.campaignsUsers = action.campaignsUsers;
      return newState;

    case CAMPAIGNS_LIST.SET_EMAIL_USERS:
      newState.emailUsers = action.emailUsers;
      return newState;

    case CAMPAIGNS_LIST.SUCCESS:
      newState.loading = false;
      newState.page = newState.page + 1;
      if (action.payload.isFiltered) newState.data = action.payload.campaignsList;
      else newState.data = [...state.data, ...action.payload.campaignsList];
      newState.totalCount = action.payload.totalCount;
      return newState;

    case CAMPAIGNS_LIST.RESET_CAMPAIGN_PAGE:
      newState.page = 0;
      return newState;

    case CAMPAIGNS_LIST.PREV_ID:
      newState.reset = newState.prevCampaignId !== action.payload ? true : false;
      newState.prevCampaignId = action.payload;
      return newState;
    case CAMPAIGNS_LIST.RESET_FLAG:
      newState.reset = true;
      newState.data = [];
      newState.page = 0;
      // newState.prevCampaignId = action.payload;
      return newState;

    case CAMPAIGNS_LIST.LOAD:
      newState.loading = true;
      return newState;

    case CAMPAIGNS_LIST.ADD_NEW:
      let newCampaign = action.payload;
      newCampaign.last_update = "just now";
      if (action.similarContactsCount) {
        newCampaign.total_contacts = action.similarContactsCount;
      }
      newState.page = state.page + 1;
      newState.data = [newCampaign, ...state.data];
      newState.totalCount = newState.totalCount + 1;
      return newState;

    case CAMPAIGNS_LIST.ERROR_SEARCH_TERM:
      newState.success = action.success;
      newState.message = action.message;
      return newState;
    case CAMPAIGNS_LIST.ERROR_SEARCH_TERM_LOADING:
      newState.loading = false;
      return newState;

    case CAMPAIGNS_LIST.FAIL:
      newState.loading = false;
      return newState;

    case CAMPAIGNS_LIST.UPDATE_THUMBNAIL:
      let updatedItem = state.data.map((item) => {
        if (item.campaign_id.toString() == action.campaign_id) {
          let campaign = { ...item };
          campaign.thumbnails[0] = action.image;
          return campaign;
        }
        return item;
      });
      newState.data = updatedItem;
      return newState;

    case CAMPAIGNS_LIST.UPDATE_ASSET_COUNT:
      let id = action.campaign_id;
      let add = action.add;
      let currIndex = 0;
      let updatedData = state.data.map((item, index) => {
        if (item.campaign_id.toString() == id) {
          let updatedItem = { ...item };
          if (add) {
            updatedItem.emails_count = item.emails_count + 1;
          } else {
            updatedItem.emails_count = item.emails_count - 1;
          }
          updatedItem.last_update = "just now";
          currIndex = index;
          return updatedItem;
        }
        return item;
      });
      if (updatedData.length > 0) {
        const currItem = updatedData[currIndex];
        updatedData.splice(currIndex, 1);
        newState.data = [currItem, ...updatedData];
      }
      return newState;

    case CAMPAIGN_NAME_UPDATE.SUCCESS:
      const updatedCampaignObj = newState.data.filter(
        (campaignObj) => campaignObj.campaign_id === parseInt(action.payload[0])
      );
      updatedCampaignObj[0].name = action.payload[1];
      // updatedCampaignObj[0].last_update = "just now";
      newState.data = [...state.data];
      return newState;
    case CAMPAIGN_DELETE.SUCCESS:
      let campaignData = [...state.data];
      let newData = campaignData.filter((item: any) => item.campaign_id !== action.payload);
      newState.data = [...newData];
      newState.totalCount = newState.totalCount - 1;
      return newState;
    case CAMPAIGN_SENT_EDITIONS.LOAD_SUCCESS:
      newState.sentEditionLoading = false;
      if (action.payload.sendEditionsinCampaign) {
        newState.sentEditions = [...action?.payload?.sendEditionsinCampaign];
      }
      if (action.payload.assetName) {
        newState.sentEditionsAssetName = action.payload.assetName;
      }
      if (action.payload.assetType) {
        newState.sentEditionsAssetType = action.payload.assetType;
      }
      if (action.payload.assetKeywords) {
        newState.sentEditionsAssetKeywords = action.payload.assetKeywords;
      }
      return newState;
    case CAMPAIGN_SENT_EDITIONS.KEYWORDS_UPDATE:
      newState.sentEditionsAssetKeywords = action.payload;
      return newState;
    case CAMPAIGN_SENT_EDITIONS.LOAD:
      newState.sentEditionLoading = true;
      return newState;
    case CAMPAIGN_SENT_EDITIONS.LOAD_FAIL:
      newState.sentEditionLoading = false;
      return newState;

    case EMAIL_BROWSER.REMOVE_EMAIL:
      if (action.payload.campaignId) {
        newState.data = newState.data.map((item) => {
          let object = { ...item };
          if (item.campaign_id === action.payload.campaignId) {
            object.emails_count--;
          }
          return object;
        });
      }
      return newState;
    case ASSET_DELETED:
      let data = state.data;
      let index = data.findIndex((item) => item.campaign_id === action.payload);
      if (index > -1) {
        data[index].emails_count = data[index].emails_count - 1;
        data[index].last_update = "just now";
      }
      newState.data = [...data];
      return newState;
    case CAMPAIGNS_LIST.RESET:
      newState.loading = false;
      newState.page = 0;
      newState.data = [];
      return newState;

    case CREATE_NEW_DRAFT_EDITION.LOAD_SUCCESS:
      newState.createNewDraftLoading = false;
      newState.sentEditions = [action.payload, ...state.sentEditions];
      return newState;
    case CREATE_NEW_DRAFT_EDITION.LOAD:
      newState.createNewDraftLoading = true;
      return newState;
    case CREATE_NEW_DRAFT_EDITION.LOAD_FAIL:
      newState.createNewDraftLoading = false;
      return newState;

    case CAMPAIGN_SENT_EDITIONS.SET_NAME:
      newState.sentEditionsAssetName = action.payload;
      return newState;

    case CAMPAIGN_SENT_EDITIONS.SET_VERSION_SUBJECT_LOADING:
      newState.sentEditionUpdateSubjectLoading = true;
      return newState;

    case CAMPAIGN_SENT_EDITIONS.LOADER_HIDE:
      newState.sentEditionUpdateSubjectLoading = false;
      return newState;

    case CAMPAIGN_SENT_EDITIONS.SET_VERSION_SUBJECT_SUCCESS:
      const nextState = produce(newState, (draft) => {
        draft.sentEditions.map((li, index) => {
          if (li.version_id === action.payload.versionId) {
            li.subject = action.payload.subject;
            li.name = action.payload.subject;
          }
        });
      });
      return nextState;

    case CAMPAIGNS_LIST.CLONE_IN_PROGRESS:
      newState.cloningInProgress = action.payload;
      return newState;

    case CAMPAIGNS_LIST.CLONE:
      let campList = state.data;

      let indexOfCamp = campList.findIndex(
        (item) => item.campaign_id.toString() === action.payload.campId.toString()
      );

      const resData = action.payload.data;

      let clonedCampData = {} as ICampaignItem;

      clonedCampData.campaign_id = resData.campaign_id;
      clonedCampData.emails_count = resData.emails_count;
      clonedCampData.last_update = resData.updated_on;
      clonedCampData.name = resData.campaign_name;
      clonedCampData.thumbnails = campList[indexOfCamp].thumbnails;
      clonedCampData.total_clicks = 0;
      clonedCampData.total_contacts = 0;
      clonedCampData.total_delivered = 0;
      clonedCampData.total_open = 0;
      clonedCampData.total_sent = 0;

      newState.data.splice(indexOfCamp + 1, 0, clonedCampData);

      newState.data = [...newState.data];
      newState.totalCount = newState.totalCount + 1;
      newState.cloningInProgress = false;

      return newState;

    case CAMPAIGNS_LIST.APPEND_CAMPAIGN_AT_START:
      newCampaign = action.payload;
      newCampaign.last_update = "just now";
      newState.data = [...[newCampaign], ...state.data];
      return newState;

    default:
      return state;
  }
};

export const recommendedListsReducer = (
  state = recommendedListsInitialState,
  action: IRecommendedAudienceListAction
) => {
  const newState = { ...state };
  switch (action.type) {
    case CREATE_CAMPAIGN_RECOMMENDED_LISTS.LOAD:
      newState.loading = true;
      return newState;
    case CREATE_CAMPAIGN_RECOMMENDED_LISTS.SUCCESS:
      newState.loading = false;
      newState.data = [...state.data, ...action.payload];
      newState.totalLists = action.totalLists;
      return newState;
    case CREATE_CAMPAIGN_RECOMMENDED_LISTS.FAIL:
      newState.loading = false;
      return newState;
    case CREATE_CAMPAIGN_RECOMMENDED_LISTS.RESET:
      newState.loading = false;
      newState.data = [];
      return newState;
    case CREATE_CAMPAIGN_RECOMMENDED_LISTS.CLEAR_DATA:
      newState.data = [];
      return newState;

    default:
      return state;
  }
};

const initialGraphDataState: ILoadingOptionsWithData = {
  loading: false,
  data: {},
  startDate: "",
  endDate: "",
  userId: "default",
  isEmpty: false,
};

export const campaignAssetGraphReducer = (
  state: ILoadingOptionsWithData = initialGraphDataState,
  action: IGraphDataAction
) => {
  const newState: ILoadingOptionsWithData = { ...state };
  switch (action.type) {
    case CAMPAIGNS_GRAPH_DATA.LOAD_SUCCESS:
      newState.loading = false;
      newState.data = { ...state.data, ...action.payload.data };
      newState.startDate = action.start_date;
      newState.endDate = action.end_date;
      newState.userId = action.user_id;
      return newState;

    case CAMPAIGNS_GRAPH_DATA.LOAD:
      newState.loading = true;
      newState.data = {};
      return newState;

    case CAMPAIGNS_GRAPH_DATA.LOAD_FAIL:
      newState.loading = false;
      newState.data = {};
      return newState;

    case CAMPAIGNS_GRAPH_DATA.SET_DATES:
      if (action.start_date && action.end_date) {
        newState.startDate = action.start_date;
        newState.endDate = action.end_date;
      }
      return newState;

    case CAMPAIGNS_GRAPH_DATA.SET_USER:
      if (action.user_id) newState.userId = action.user_id;
      return newState;

    case CAMPAIGNS_GRAPH_DATA.CLEAR:
      return initialGraphDataState;

    default:
      return state;
  }
};

export const recommendedPeopleReducer = (
  state = recommendedPeopleInitialState,
  action: IRecommendedAudienceContactAction
) => {
  const newState = { ...state };
  switch (action.type) {
    //* recommended contacts/people reducer
    // load
    case CREATE_CAMPAIGN_RECOMMENDED_CONTACTS.LOAD:
      newState.loading = true;
      return newState;

    // clear data when new api is called to fetch new data from offset 0
    case CREATE_CAMPAIGN_RECOMMENDED_CONTACTS.CLEAR_DATA:
      newState.data = [];
      return newState;

    // success
    case CREATE_CAMPAIGN_RECOMMENDED_CONTACTS.SUCCESS:
      newState.loading = false;
      newState.data = [...newState.data, ...action.payload];
      newState.totalContacts = action.totalContacts;
      if (action.isSelectAll) {
        newState.selectedRecommendedContactsIds = [
          ...newState.selectedRecommendedContactsIds,
          ...action.payload.map((contact) => contact.id),
        ];
        newState.selectedRecommendedContacts = [...newState.selectedRecommendedContacts, ...action.payload];
      }
      return newState;

    // fail
    case CREATE_CAMPAIGN_RECOMMENDED_CONTACTS.FAIL:
      newState.loading = false;
      return newState;

    // reset recommended contacts
    case CREATE_CAMPAIGN_RECOMMENDED_CONTACTS.RESET:
      newState.data = [];
      newState.loading = false;
      return newState;

    // select/unselect contacts
    case CREATE_CAMPAIGN_RECOMMENDED_CONTACTS.SET_SELECTED_CONTACTS:
      if (newState.selectedRecommendedContactsIds.includes(action?.selectedContact.id)) {
        newState.selectedRecommendedContactsIds = newState.selectedRecommendedContactsIds?.filter(
          (id) => id !== action?.selectedContact.id
        );
        newState.selectedRecommendedContacts = newState.selectedRecommendedContacts?.filter(
          (contact) => contact.id !== action?.selectedContact.id
        );
      } else {
        newState.selectedRecommendedContactsIds.push(action?.selectedContact.id);
        newState.selectedRecommendedContacts.push(action?.selectedContact);
      }
      return newState;

    // reset selected contacts
    case CREATE_CAMPAIGN_RECOMMENDED_CONTACTS.RESET_SELECTED_CONTACTS:
      newState.selectedRecommendedContacts = [];
      newState.selectedRecommendedContactsIds = [];
      return newState;

    // select/unselect all contacts
    case CREATE_CAMPAIGN_RECOMMENDED_CONTACTS.SET_SELECT_ALL:
      newState.isSelectAllRecommendedContacts = true;
      newState.selectedRecommendedContactsIds = newState.data.map((contact) => contact.id);
      newState.selectedRecommendedContacts = newState.data;
      return newState;

    case CREATE_CAMPAIGN_RECOMMENDED_CONTACTS.RESET_SELECT_ALL:
      newState.isSelectAllRecommendedContacts = false;
      newState.selectedRecommendedContactsIds = [];
      newState.selectedRecommendedContacts = [];
      return newState;

    //* dynamic people/contacts reducer
    // load
    case DYNAMIC_AUDIENCE_MATCHING.LOAD:
      newState.dynamicAudienceLoading = true;
      return newState;

    // clear data when new api is called to fetch new data from offset 0
    case DYNAMIC_AUDIENCE_MATCHING.CLEAR_DATA:
      newState.dynamicAudienceData = [];
      return newState;

    // set dynamic keywords
    case DYNAMIC_AUDIENCE_MATCHING.DYNAMIC_KEYWORDS:
      newState.dynamicKeywords = action.dynamicKeywords;
      return newState;

    // set search term
    case DYNAMIC_AUDIENCE_MATCHING.SEARCH_TERM:
      newState.searchTerm = action.searchTerm;
      return newState;

    // success
    case DYNAMIC_AUDIENCE_MATCHING.SUCCESS:
      newState.dynamicAudienceLoading = false;
      newState.dynamicAudienceData = [...newState.dynamicAudienceData, ...action.payload];
      newState.dynamicAudienceTotalContacts = action.totalContacts;
      return newState;

    // fail
    case DYNAMIC_AUDIENCE_MATCHING.FAIL:
      newState.dynamicAudienceLoading = false;
      newState.dynamicAudienceData = [];
      return newState;

    // reset dynamic audience
    case DYNAMIC_AUDIENCE_MATCHING.DYNAMIC_KEYWORDS_RESET:
      newState.dynamicAudienceLoading = false;
      newState.dynamicKeywords = [];
      newState.searchTerm = "";
      return newState;

    // select/unselect contacts
    case DYNAMIC_AUDIENCE_MATCHING.ALREADY_SELECTED_CONTACTS:
      newState.alreadySelectedContacts = action.alreadySelectedContacts;
      return newState;

    default:
      return state;
  }
};

export const getCampaignNamesReducer = (state = getCampaignNamesInitialState, action: ICampaignsNamesAction) => {
  const newState = { ...state };
  switch (action.type) {
    case GET_CAMPAIGNS_NAMES_ONLY.LOAD:
      newState.loading = true;
      if (action.search_campaign) newState.searchTerm = action.search_campaign;
      return newState;
    case GET_CAMPAIGNS_NAMES_ONLY.SUCCESS:
      newState.loading = false;
      newState.totalCount = action.totalCount;
      if (action.newlyAdded) {
        let exists = newState.data.filter((item: any) => item.campaign_id === action.payload[0].campaign_id);
        if (exists.length <= 0) {
          newState.data = [...action.payload, ...state.data];
        }
      } else {
        newState.data = [...state.data, ...action.payload];
      }

      return newState;
    case GET_CAMPAIGNS_NAMES_ONLY.FAIL:
      newState.loading = false;
      return newState;
    case GET_CAMPAIGNS_NAMES_ONLY.UPDATE:
      newState.loading = false;
      newState.data = [...action.payload];
      return newState;
    case GET_CAMPAIGNS_NAMES_ONLY.UPDATE_NAME:
      newState.loading = false;
      if (action.payload) {
        let campaignId = parseInt(action.payload[0].campaign_id);
        let campaignName = action.payload[0].name;
        let newData = state.data.map((item) => {
          if (item.campaign_id === campaignId) {
            item.name = campaignName;
          }
          return item;
        });
        newState.data = [...newData];
      }
      return newState;

    case CAMPAIGN_NAME_DELETE.SUCCESS:
      newState.data = newState.data.filter((item: any) => item.campaign_id !== action.payload);
      return newState;

    case GET_CAMPAIGNS_NAMES_ONLY.RESET:
      newState.data = [];
      newState.loading = false;
      newState.totalCount = 0;
      newState.searchTerm = "";
      return newState;

    default:
      return state;
  }
};

export const keywordsExplorerReducer = (state = keywordsExplorerInitialState, action: IKeywordsExplorerAction) => {
  const newState = { ...state };
  switch (action.type) {
    case TEST_CAMPAIGN_SEARCH_TERM.LOAD:
      newState.loading = true;
      newState.data = new Array<IArticlesItem>();
      return newState;
    case TEST_CAMPAIGN_SEARCH_TERM.SUCCESS:
      newState.data = [...action.payload];
      newState.loading = false;
      return newState;
    case TEST_CAMPAIGN_SEARCH_TERM.FAIL:
      newState.loading = false;
      return newState;
    case TEST_CAMPAIGN_SEARCH_TERM.RESET:
      newState.data = new Array<IArticlesItem>();
      return newState;

    default:
      return state;
  }
};

// Adhoc asset flow reducer
export const adHocTemplatesReducer = (state = getTemplatesInitialState, action: ITemplatesAction) => {
  const newState = { ...state };
  switch (action.type) {
    case ADHOC.TEMPLATES_LOAD:
      newState.loading = true;
      return newState;
    case ADHOC.RESET_PAGE_NUMBER:
      if (action.templateType === TEMPLATES_TYPE.FEATURED) {
        newState.featured.templates = [];
        newState.featured.page = 0;
        newState.featured.total_templates = 0;
      }
      if (action.templateType === TEMPLATES_TYPE.MY_TEMPLATES) {
        newState.my_templates.templates = [];
        newState.my_templates.page = 0;
        newState.my_templates.total_templates = 0;
      }
      if (action.templateType === TEMPLATES_TYPE.SHARED) {
        newState.shared.templates = [];
        newState.shared.page = 0;
        newState.shared.total_templates = 0;
      }
      return newState;
    case ADHOC.FILTER_TEMPLATE:
      newState.loading = false;
      if (action.templateType === TEMPLATES_TYPE.FEATURED) {
        if (newState.featured.page === 0) {
          newState.featured.total_templates = action.featured.total_templates;
          newState.featured.templates = action.featured.templates;
        } else {
          newState.featured.templates = [...state.featured.templates, ...action.featured.templates];
        }
        newState.featured.page = newState.featured.page + 1;
      }
      if (action.templateType === TEMPLATES_TYPE.MY_TEMPLATES) {
        if (newState.my_templates.page === 0) {
          newState.my_templates.total_templates = action.my_templates.total_templates;
          newState.my_templates.templates = action.my_templates.templates;
        } else {
          newState.my_templates.templates = [...newState.my_templates.templates, ...action.my_templates.templates];
        }
        newState.my_templates.page = newState.my_templates.page + 1;
      }
      if (action.templateType === TEMPLATES_TYPE.SHARED) {
        if (newState.shared.page === 0) {
          newState.shared.total_templates = action.shared.total_templates;
          newState.shared.templates = action.shared.templates;
        } else {
          newState.shared.templates = [...newState.shared.templates, ...action.shared.templates];
        }
        newState.shared.page = newState.shared.page + 1;
      }
      return newState;
    case ADHOC.TEMPLATES_SUCCESS:
      // Loading templates
      newState.loading = false;
      if (action.templateType === TEMPLATES_TYPE.FEATURED) {
        if (newState.featured.page === 0) {
          newState.featured.total_templates = action.featured.total_templates;
          newState.featured.templates = action.featured.templates;
        } else {
          newState.featured.templates = [...state.featured.templates, ...action.featured.templates];
        }
        newState.featured.page = newState.featured.page + 1;
      }
      if (action.templateType === TEMPLATES_TYPE.MY_TEMPLATES) {
        if (newState.my_templates.page === 0) {
          newState.my_templates.total_templates = action.my_templates.total_templates;
          newState.my_templates.templates = action.my_templates.templates;
        } else {
          newState.my_templates.templates = [...state.my_templates.templates, ...action.my_templates.templates];
        }
        newState.my_templates.page = newState.my_templates.page + 1;
      }
      if (action.templateType === TEMPLATES_TYPE.SHARED) {
        if (newState.shared.page === 0) {
          newState.shared.total_templates = action.shared.total_templates;
          newState.shared.templates = action.shared.templates;
        } else {
          newState.shared.templates = [...state.shared.templates, ...action.shared.templates];
        }
        newState.shared.page = newState.shared.page + 1;
      }
      return newState;

    case ADHOC.ERROR_SEARCH_TERM:
      newState.success = action.payload.success;
      newState.message = action.payload.message;
      return newState;

    case ADHOC.ERROR_SEARCH_TERM_LOADING:
      newState.loading = false;
      return newState;

    case ADHOC.TEMPLATES_FAIL:
      newState.loading = false;
      return newState;
    case ADHOC.SAVE_LOAD:
      newState.loading = false;
      return newState;

    case ADHOC.SAVE_FAIL:
      newState.loading = false;
      return newState;

    case ADHOC.RESET_URL:
      newState.loading = false;
      newState.redirectUrl = action.redirectUrl;
      return newState;
    default:
      return state;
  }
};
